import { Children, cloneElement, useMemo, useState } from 'react';

import { useApplicationsGetQuery } from '../../Common/Queries/applicationsQueries';

import { ALL_DATA_LIMIT } from '../../constants';

export const PreScreeningListContainer = ({ children }) => {
  const [source, setSource] = useState();

  const view = 'PRE_SCREENING';

  const queryParams = useMemo(
    () => ({
      view,
      limit: ALL_DATA_LIMIT,
      ...(source ? { uploadedBy: source } : {}),
    }),
    [source, view]
  );

  const screeningApplication = useApplicationsGetQuery(queryParams);

  const child = Children.only(children);

  return cloneElement(child, { screeningApplication, setSource });
};
